import classNames from "classnames";
import { HTMLAttributeAnchorTarget } from "react";
import { NavLink } from "react-router-dom";

import styles from "./index.module.scss";

interface ICustomNavLinkProps {
  label: string;
  to: string;
  target?: HTMLAttributeAnchorTarget;
  className?: string;
}

function CustomNavLink({
  label,
  to,
  target,
  className = "",
}: ICustomNavLinkProps) {
  if (to.startsWith("http://") || to.startsWith("https://")) {
    return (
      <a
        href={to}
        target={target}
        rel="noopener noreferrer"
        className={classNames(styles.link, className)}>
        {label}
      </a>
    );
  }

  return (
    <NavLink
      to={to}
      target={target}
      className={({ isActive }) =>
        classNames(styles.link, className, {
          [styles.link_active]: isActive,
        })
      }>
      {label}
    </NavLink>
  );
}

export default CustomNavLink;
